import { AuthUser, AuthDeveloper } from "../models/authUserModel"
import { nextAuthUrl } from "./nextApi"

// Storage de sesión:
// - Realm `customer`: la sesión vive en cookies httpOnly que setea Next
//   (propi_session, propi_refresh, propi_user_data) en `.propilatam.com` /
//   `.propilatam.dev`. El JS de la SPA no puede leer la cookie, pero el
//   AppRouter hidrata el slice `auth` al boot llamando a `/api/auth/session`.
//   Para ese realm `user.token` queda vacío y los services consumen via el
//   proxy de Next con withCredentials (la cookie viaja sola).
// - Realms legacy (landlord, investor, developer, email/password): siguen el
//   flujo viejo con token + rft en localStorage['auth'].

export const getAuth = () => {
    return localStorage.getItem('auth_legacy') || ''
}

export const setAuth = (user: AuthUser) => {
    localStorage.setItem('auth_legacy', JSON.stringify(user))
}
export const setAuthDeveloper = (user: AuthDeveloper) => {
    localStorage.setItem('authDev', JSON.stringify(user))
}

export const getAuthDeveloper = () => {
    return localStorage.getItem('authDev') || ''
}

export const unsetAuth = () => {
    localStorage.removeItem('auth_legacy')
}

export const getAuthToken = (user: AuthUser) => {
    return isLoggedIn(user) ? (user.token || '') : ''
}

// Un user logueado tiene realm seteado. El token es opcional: en el flujo
// nuevo de customer, el token vive en la cookie httpOnly y user.token = ''.
export const isLoggedIn = (user: AuthUser) => {
    return Boolean(user && user.realm)
}

export const setLastPath = (path: string) => {
    localStorage.setItem('lpath', path)
}

export const getLastPath = () => {
    return localStorage.getItem('lpath') || ''
}

export const removeLastPath = () => {
    localStorage.removeItem('lpath')
}

export const customDelay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

// Después de un login legacy (email/password, login-by-code, registro), sube
// el blob a Next para que setee las cookies httpOnly. Si Next acepta, borra
// localStorage['auth'] — la cookie es la fuente de verdad de ahí en adelante.
// Si falla, queda el localStorage como fallback (igual que antes).
export const adoptLegacy = async (user: AuthUser, country: string): Promise<boolean> => {
    if (!user?.token || !user?.rft) return false

    // El schema de Next exige `name` o `first_name`. Algunos backends devuelven
    // `name: null` para usuarios viejos — sintetizamos un fallback para que el
    // body siempre matchee.
    const fallbackName = user.name || (user as any).first_name || user.last_name || 'User'
    const body = {
        ...user,
        name: user.name || fallbackName,
        first_name: (user as any).first_name || user.name || fallbackName,
    }

    try {
        const res = await fetch(nextAuthUrl(country, 'adopt-legacy'), {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        })
        if (res.ok) {
            localStorage.removeItem('auth_legacy')
            return true
        }
        const errBody = await res.text().catch(() => '')
        console.warn('adopt-legacy failed', res.status, errBody)
        return false
    } catch (err) {
        console.warn('adopt-legacy network error', err)
        return false
    }
}
